import React from 'react'
import ReactDOM from 'react-dom'
import ReactDOMClient from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { BnClient } from './components/Client'
import './index.css'

// HostComponent = 5, HostText = 6, HostHoistable = 26, HostSingleton = 27.
// The latter two can exist in newer React DOM builds.
const HOST_TAGS = new Set([5, 6, 26, 27])

function fiberToDOMNode(fiber) {
  if (!fiber) return null

  let node = fiber

  while (node) {
    if (HOST_TAGS.has(node.tag) && node.stateNode) {
      return node.stateNode
    }

    if (node.child) {
      node = node.child
      continue
    }

    while (node && !node.sibling) {
      if (node === fiber) return null
      node = node.return
    }

    if (node) node = node.sibling
  }

  return null
}

function fallbackFindDOMNode(instance) {
  if (instance == null) return null

  if (
    instance.nodeType === Node.ELEMENT_NODE ||
    instance.nodeType === Node.TEXT_NODE ||
    instance.nodeType === Node.DOCUMENT_NODE
  ) {
    return instance
  }

  if (instance._reactInternals) {
    return fiberToDOMNode(instance._reactInternals)
  }

  if (instance._reactInternalInstance) {
    return fiberToDOMNode(instance._reactInternalInstance)
  }

  if (instance.current) return fallbackFindDOMNode(instance.current)
  if (instance.base) return fallbackFindDOMNode(instance.base)
  if (instance.el) return fallbackFindDOMNode(instance.el)
  if (instance.node) return fallbackFindDOMNode(instance.node)
  if (instance._node) return fallbackFindDOMNode(instance._node)

  return null
}

// Mobiscroll still expects findDOMNode, which React 19 no longer exposes.
ReactDOM.findDOMNode = fallbackFindDOMNode

const root = ReactDOMClient.createRoot(
  document.getElementById('root')
)

root.render(
  <BrowserRouter>
    <BnClient />
  </BrowserRouter>
)



